<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useGameStore } from 'stores/game-store'
import { useQuasar } from 'quasar'
import { useRoute,useRouter } from 'vue-router'
import { db } from 'src/models/db'
const hydrateDemoData = async () => {
  const gameStore = useGameStore()
  try {
    // Cache buster ensures Netlify doesn't serve a stale file if you update it
    const response = await fetch(`/hydrate.json?t=${Date.now()}`)

    if (response.ok) {
      // IMPORTANT: Grab the raw text instead of .json() because your store method
      // explicitly expects a string parameter!
      const jsonString = await response.text()

      // Pass the string to your existing import method
      await gameStore.importDatabaseFromJSON(jsonString)

      console.log('Demo data successfully hydrated from /hydrate.json!')
    } else {
      console.log('No hydrate.json found. Proceeding normally.')
    }
  } catch (error) {
    console.warn('Silent fail: Hydration skipped.', error)
  }
}
const $q = useQuasar() // Initialize Quasar plugins
const route = useRoute()
const router = useRouter()

onMounted(async () => {
// 1. Wait for Vue Router to figure out what page the user is actually on
  await router.isReady()

  // 2. Check the route by its exact Name to avoid intercepting the Observer page
  if (route.name !== 'ObserverScout') {

    // 3. Check if the user already has games saved locally
    const existingGames = await db.games.toArray()

    if (existingGames.length > 0) {
      // Prompt the user before hydrating
      $q.dialog({
        title: 'Load Demo Data?',
        message: 'It looks like you already have saved games. Would you like to reload the demo data? This may overwrite your existing demo game.',
        color: 'primary',
        cancel: true,
        persistent: true
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
      }).onOk(async () => {
        $q.loading.show({ message: 'Hydrating Demo Data...' })
        await hydrateDemoData()
        $q.loading.hide()
        $q.notify({ message: 'Demo data loaded successfully.', color: 'positive', position: 'bottom' })
      })
      // If they click cancel, it just does nothing and leaves their local data untouched!
    } else {
      // If it's a fresh install with no games, just hydrate automatically
      await hydrateDemoData()
    }
  }
})
</script>
